import { assign } from 'lodash';
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IAddress extends IModel {
	type?: number;
	street?: string;
	city?: string;
	region?: string;
	postalCode?: string;
	country?: string;
	installArea?: string;
	isEmpty(): boolean;
}

const addressFactory = modelFactory.createFactory<IAddress>('Address', assign({}, model, {
	type: {
		setFilters: valueFilters.toNumber,
		rules: validator.enum('addressTypes', true) // disallow 0
	},
	street: {
		rules: validator.required()
	},
	city: {
		rules: validator.required()
	},
	region: {
		rules: validator.required()
	},
	postalCode: {
		setFilters: valueFilters.toString,
		rules: validator.required()
	},
	country: {
		setFilters: valueFilters.toString
	},
	installArea: {
		setFilters: valueFilters.toString
	},
	isEmpty: function () {
		return !this.street && !this.city && !this.region && !this.postalCode && !this.country;
	}
}));

export default addressFactory;